var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const RECOMMENDED_CODE_VERIFIER_LENGTH = 96;
const PKCE_CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
export const parseWwwAuthenticateHeader = (header) => {
    const headerMap = header
        .slice('Bearer '.length)
        .replace(/"/g, '')
        .split(',')
        .map(pair => {
        const [key, value] = pair.trim().split('=');
        return { [key]: value };
    })
        .reduce((prev, next) => (Object.assign(Object.assign({}, prev), next)), {});
    return {
        realm: headerMap.realm,
        error: headerMap.error,
        errorDescription: headerMap.error_description,
        errorUri: headerMap.error_uri
    };
};
const base64urlEncode = (value) => {
    let base64 = btoa(value);
    base64 = base64.replace(/\+/g, '-');
    base64 = base64.replace(/\//g, '_');
    base64 = base64.replace(/=/g, '');
    return base64;
};
export const extractParamFromUrl = (param, url) => {
    let queryString = url.split('?');
    if (queryString.length < 2) {
        return undefined;
    }
    queryString = queryString[1].split('#');
    const parts = queryString[0].split('&');
    for (const part of parts) {
        const [key, value] = part.split('=');
        if (key === param) {
            return decodeURIComponent(value);
        }
    }
    return undefined;
};
export const objectToQueryString = (dict) => Object.entries(dict).map(([key, val]) => `${key}=${encodeURIComponent(val)}`).join('&');
export const generatePKCECodeChallengeAndVerifier = () => __awaiter(void 0, void 0, void 0, function* () {
    const output = new Uint32Array(RECOMMENDED_CODE_VERIFIER_LENGTH);
    crypto.getRandomValues(output);
    const codeVerifier = base64urlEncode(Array
        .from(output)
        .map((num) => PKCE_CHARSET[num % PKCE_CHARSET.length])
        .join(''));
    const buffer = yield crypto
        .subtle
        .digest('SHA-256', (new TextEncoder()).encode(codeVerifier));
    const hash = new Uint8Array(buffer);
    let binary = '';
    const hashLength = hash.byteLength;
    for (let i = 0; i < hashLength; i++) {
        binary += String.fromCharCode(hash[i]);
    }
    const codeChallenge = base64urlEncode(binary);
    return { codeChallenge, codeVerifier };
});
export const generateRandomState = (lengthOfState) => {
    const output = new Uint32Array(lengthOfState);
    crypto.getRandomValues(output);
    return Array
        .from(output)
        .map((num) => PKCE_CHARSET[num % PKCE_CHARSET.length])
        .join('');
};
